export type ConvertableCurrencyListModel = {
  'currencyFromList': string[];
  'currencyToList': string[];
}

export type PaymentMethodCurrencyConverterItem = {
  currencyFromList: string[];
  currencyTo: string;
};

export type PaymentMethodCurrencyConverterRequest = {
  paymentMethodId: string;
  currencyConverterList: PaymentMethodCurrencyConverterItem[];
};

export const DEFAULT_CONVERTABLE_CURRENCY_LIST: ConvertableCurrencyListModel = {
  currencyFromList: [],
  currencyToList: [],
};

const DEFAULT_PAYMENT_METHOD_CURRENCY = 'EUR';

export const DEFAULT_PAYMENT_METHOD_CURRENCY_CONVERTER_ITEM: PaymentMethodCurrencyConverterItem = {
  currencyFromList: [],
  currencyTo: DEFAULT_PAYMENT_METHOD_CURRENCY,
};

export const EMPTY_PAYMENT_METHOD_CURRENCY_CONVERTER_ITEM: PaymentMethodCurrencyConverterItem = {
  currencyFromList: [],
  currencyTo: '',
};

export type ConverterKey = 'currencyFromList' | 'currencyTo';
